import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useLocales } from '@/locales';
import { BadgeCheck, FileText } from 'lucide-react';

const ClientCredentials = memo(({ credentials, errors, onChange }) => {
  const { translate } = useLocales();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="client-tin">{translate('TIN') || 'TIN'}</Label>
        <div className="relative">
          <Input
            id="client-tin"
            type="text"
            placeholder={translate('Enter_TIN') || 'Enter TIN'}
            className="pr-10"
            value={credentials.TIN}
            onChange={onChange('TIN')}
            aria-invalid={Boolean(errors.TIN)}
          />
          <BadgeCheck className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="client-contract">
          {translate('Contract_ID') || 'Contract ID'}
        </Label>
        <div className="relative">
          <Input
            id="client-contract"
            type="text"
            placeholder={
              translate('Enter_contractId_optional') ||
              'Enter contract ID (optional)'
            }
            className="pr-10"
            value={credentials.contractId}
            onChange={onChange('contractId')}
            aria-invalid={Boolean(errors.contractId)}
          />
          <FileText className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="client-alias">{translate('Alias') || 'Alias'}</Label>
        <div className="relative">
          <Input
            id="client-alias"
            type="text"
            placeholder={
              translate('Enter_alias_optional') || 'Enter alias (optional)'
            }
            className="pr-10"
            value={credentials.alias}
            onChange={onChange('alias')}
            aria-invalid={Boolean(errors.alias)}
          />
          <FileText className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
        </div>
      </div>
    </div>
  );
});

ClientCredentials.displayName = 'ClientCredentials';

ClientCredentials.propTypes = {
  credentials: PropTypes.shape({
    TIN: PropTypes.string,
    contractId: PropTypes.string,
    alias: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    TIN: PropTypes.bool,
    contractId: PropTypes.bool,
    alias: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ClientCredentials;
